import { Link } from "react-router-dom";
import styled from "styled-components";
import { Logout } from "../../components/Logout";
import { useTheme } from "@mui/material/styles";
import { Typography } from "@mui/material";
import { Company, Employee } from "../../types";
import { CircleUser } from "lucide-react";
import YLLWLOGO from "../../assets/Yllw_Inventory.svg";
import { useRef, useEffect } from "react";
const PageHeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-left: 15px;
    padding-right: 15px;
    align-items: center;
`;

const IconWrapper = styled.div`
    font-size: 40px !important;
`;

const EmployeeInfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;
const Logo = styled.img`
    margin-top: 5px;
    width: 120px;
    height: 22px;
`;

type Props = {
    employee?: Employee;
    company?: Company;
    pageSubtitle?: string;
};
export const MainMenuHeader = (props: Props) => {
    const theme = useTheme();
    const headingRef = useRef<HTMLHeadingElement>(null);

    useEffect(() => {
        headingRef.current?.focus();
        setTimeout(() => {
            headingRef.current?.blur();
        }, 0);
    }, []);
    return (
        <PageHeaderWrapper>
            <Link to="/account">
                <IconWrapper>
                    <CircleUser
                        style={{
                            color: theme.palette.primary.main,
                        }}
                        size={32}
                    />
                </IconWrapper>
            </Link>
            <EmployeeInfoWrapper>
                <Logo src={YLLWLOGO} />
                <Typography
                    color="#8c8c8c"
                    fontWeight={500}
                    fontSize={14}
                    marginTop={"2px"}
                    component="h1"
                    variant="h1"
                    tabIndex={0}
                    ref={headingRef}
                    sx={{ fontFamily: "Inter, sans-serif" }}
                >
                    {"Dashboard"}
                </Typography>
                <Typography>{props.pageSubtitle}</Typography>
            </EmployeeInfoWrapper>
            <Logout />
        </PageHeaderWrapper>
    );
};
